import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeProxyComponent } from './components/home/home-proxy/home-proxy.component';
import { CommandComponent } from '@common/components/command/command.component';
import { RedirectGuard } from './guards/redirect.guard';
import { ParticipantStatusGuard } from './guards/participant-status.guard';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: 'texas' },
    {
        path: ':community',
        canActivate: [RedirectGuard],
        children: [
            { path: '', pathMatch: 'full', redirectTo: 'en' },
            {
                path: 'register/:id',
                pathMatch: 'full',
                redirectTo: 'en/register/:id',
            },
            {
                path: 'register',
                pathMatch: 'full',
                redirectTo: 'en/register',
            },
            {
                path: 'error',
                loadChildren: () =>
                    import('./components/error/error.module').then(
                        (mod) => mod.ErrorModule,
                    ),
            },
            {
                path: ':language',
                children: [
                    {
                        path: '',
                        redirectTo: 'home',
                        pathMatch: 'full',
                    },
                    { path: 'home', component: HomeProxyComponent },
                    {
                        path: 'info',
                        loadChildren: () =>
                            import('./components/info/info.module').then(
                                (mod) => mod.InfoModule,
                            ),
                    },
                    {
                        path: 'faq',
                        loadChildren: () =>
                            import('./components/faq/faq.module').then(
                                (mod) => mod.FaqModule,
                            ),
                    },
                    {
                        path: 'contact',
                        loadChildren: () =>
                            import('./components/contact/contact.module').then(
                                (mod) => mod.ContactModule,
                            ),
                    },
                    {
                        path: 'register',
                        loadChildren: () =>
                            import(
                                './components/register/register.module'
                            ).then((mod) => mod.RegisterModule),
                    },
                    {
                        path: 'error',
                        loadChildren: () =>
                            import('./components/error/error.module').then(
                                (mod) => mod.ErrorModule,
                            ),
                    },
                    {
                        path: 'cookie-policy',
                        loadChildren: () =>
                            import(
                                './components/cookie-policy/cookie.policy.module'
                            ).then((mod) => mod.CookiePolicyModule),
                    },
                    {
                        path: 'terms-and-conditions',
                        loadChildren: () =>
                            import(
                                './components/terms-and-conditions/terms-and-conditions.module'
                            ).then((mod) => mod.TermsAndConditionsModule),
                    },
                    {
                        path: 'preferences',
                        loadChildren: () =>
                            import('./profile.module').then(
                                (mod) => mod.ProfileModule,
                            ),
                        data: { titleKey: 'preferences' },
                    },
                    {
                        path: 'privacy-policy',
                        loadChildren: () =>
                            import(
                                './components/privacy-policy/privacy-policy.module'
                            ).then((mod) => mod.PrivacyPolicyModule),
                    },
                    {
                        path: 'do/:id/:command',
                        canActivate: [ParticipantStatusGuard, AuthGuard],
                        component: CommandComponent,
                    },
                    {
                        path: 'unauthorized',
                        loadChildren: () =>
                            import(
                                './components/unauthorized/unauthorized.module'
                            ).then((mod) => mod.UnauthorizedModule),
                    },
                    { path: '**', redirectTo: 'home' },
                ],
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule],
})
export class AppRoutingModule {}
